export default __webpack_public_path__ + "ebcbcb04a72d6ecee0efff21f44cdd3b.png";